import text from './text';
import background from './background';
import button from './button';

export default {
  text,
  background,
  button,
};
